/*
*
* File JS componente Block Form
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-form.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//


//Funzione per i FloatingLabel
function floatingLabel(){
    //Sposta i floatingLabel dentro il FormControlWrap per l'effetto
    const formControlWraps = document.querySelectorAll('.wpcf7-form-control-wrap');

    if(!formControlWraps) return;

    formControlWraps.forEach(function(formControlWrap) {
        const floatingLabel = formControlWrap.parentElement.querySelector('.floating-label');

        if (floatingLabel) {
            formControlWrap.appendChild(floatingLabel);
        }
    });
}


function stepForms() {
    const step1 = document.querySelector('#step-1');
    const step2 = document.querySelector('#step-2');
    const stepBack = document.querySelector('#step-back');
    const stepNext = document.querySelector('#step-next');

    if (!step1 || !step2 || !stepBack || !stepNext) return;

    // NEXT & BACK
    stepNext.addEventListener('click', (e) => {
        e.preventDefault();
        step1.style.display = 'none';
        step2.style.display = 'block';
    });

    stepBack.addEventListener('click', (e) => {
        e.preventDefault();
        step2.style.display = 'none';
        step1.style.display = 'block';
    });


    // START VALIDATION
    // get inputs required in step 1
    let validInputsCount = 0;

    // get inputs and selects required in step 1
    const inputsAndSelectsRequired = step1.querySelectorAll('input, select');

    function checkInputs() {
        validInputsCount = 0;

        inputsAndSelectsRequired.forEach(element => {
            if ((element.tagName === 'INPUT' && element.getAttribute('aria-invalid') === 'false' && element.value.trim() !== '') ||
                (element.tagName === 'SELECT' && element.value.trim() !== '')) {
                validInputsCount++;
            }
        });

        if (validInputsCount === inputsAndSelectsRequired.length) {
            stepNext.classList.remove('disabled');
        } else {
            stepNext.classList.add('disabled');
        }
    }

    inputsAndSelectsRequired.forEach(input => {
        input.addEventListener('change', () => {
            setTimeout(checkInputs, 1); 
        });
    });

    checkInputs();

    
}

const blockForm = () => {

    floatingLabel();
    stepForms();
}

export default blockForm;

//--------------------------------------------------------------------//